import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@clerk/react'

// Layouts
import GeexLayout from './components/layout/GeexLayout'

// Clerk bridge – syncs Clerk auth with PHP backend JWT
import ClerkSync from './components/ClerkSync'

// Guards
import ProtectedRoute from './components/guards/ProtectedRoute'
import AdminRoute from './components/guards/AdminRoute'
import DoctorRoute from './components/guards/DoctorRoute'

// Public pages (no sidebar)
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import NotFound from './pages/NotFound'

// Protected pages (use GeexLayout)
import Dashboard from './pages/Dashboard'
import Consultation from './pages/Consultation'
import Letters from './pages/Letters'
import Profile from './pages/Profile'
import Admin from './pages/Admin'
import MyConsult from './pages/MyConsult'
import MyConsultOpenAI from './pages/MyConsultOpenAI'
import MyVoiceAgent from './pages/MyVoiceAgent'
import AskDrSam from './pages/AskDrSam'
import VideoChat from './pages/VideoChat'
import PatientProfile from './pages/PatientProfile'
import DoctorSetup from './pages/DoctorSetup'
import BookAppointment from './pages/BookAppointment'
import MyAppointments from './pages/MyAppointments'
import MCQTest from './pages/MCQTest'
import AskDrSamChat from './pages/AskDrSamChat'

function App() {
  const { isSignedIn, isLoaded } = useAuth()

  return (
    <>
      {/* ClerkSync runs silently in the background – no UI */}
      <ClerkSync />

      <Routes>
        {/* ── PUBLIC ROUTES (no sidebar) ── */}
        <Route path="/" element={<Home />} />

        {/* /login/* and /register/* use wildcards so Clerk can manage
            its own sub-routes (OAuth callbacks, MFA steps, etc.) */}
        <Route
          path="/login/*"
          element={
            isLoaded && isSignedIn
              ? <Navigate to="/dashboard" replace />
              : <Login />
          }
        />
        <Route
          path="/register/*"
          element={
            isLoaded && isSignedIn
              ? <Navigate to="/dashboard" replace />
              : <Register />
          }
        />

        {/* ── PROTECTED ROUTES (GeexLayout sidebar) ── */}
        <Route
          element={
            <ProtectedRoute>
              <GeexLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/letters" element={<Letters />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/my-consult" element={<MyConsult />} />
          <Route path="/my-consult-openai" element={<MyConsultOpenAI />} />
          <Route path="/my-voice-agent" element={<MyVoiceAgent />} />
          <Route path="/ask-dr-sam" element={<AskDrSam />} />
          <Route path="/video-chat" element={<VideoChat />} />
          <Route path="/patient-profile" element={<PatientProfile />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/my-appointments" element={<MyAppointments />} />
          <Route path="/mcq-test" element={<MCQTest />} />
          <Route path="/ask-dr-sam-chat" element={<AskDrSamChat />} />
        </Route>

        {/* ── DOCTOR ROUTES (doctor + admin) ── */}
        <Route
          element={
            <DoctorRoute>
              <GeexLayout />
            </DoctorRoute>
          }
        >
          <Route path="/doctor-setup" element={<DoctorSetup />} />
        </Route>

        {/* ── ADMIN ROUTES (standalone layout – no GeexLayout) ── */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

export default App
